import React from 'react'
import { string } from 'yup'
import { Input } from '@/components/Form'
import { dynamicCol } from '@/styles/shared'

const Component = () => (
  <div css={dynamicCol}>
    <Input
      label="Guest First Name"
      id="guest-first-name"
      type="text"
      name="guest-first-name"
    />
    <Input
      label="Guest Last Name"
      id="guest-last-name"
      type="text"
      name="guest-last-name"
    />
  </div>
)

const schema = string()

const initialValue = ''

export default {
  Component,
  schema,
  initialValue,
}
